import { ReactComponent as FlagIcon } from "./svg/dk-flag.svg";
import "../flag-icon.scss";

export const DKFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
